import { Icon, IconType, Popover, Table, Text } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import useCapacityMatrix from '../../hooks/useCapacityMatrix'
import { InputSelectStyled, TABLE_MARGINT_TOP } from './SkillMatrix'

export type CapacityTable = {
  skills: string
  needs: string[]
  carersWithValidSkills: number
  residentsWithNeeds: number
}

const Wrapper = styled.div`
  margin-bottom: 133px;
`

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`

const InputSelectWrapper = styled.div`
  margin-bottom: ${TABLE_MARGINT_TOP}px;
`

const TableStyled = styled(Table)`
  max-width: 100%;
  overflow-x: auto;
` as typeof Table

const CapacityMatrix = ({ testId }: { testId?: string }) => {
  const { t } = useTranslation()

  const { categories, capacityMatrixRows, onCategoryChange, getColumns } =
    useCapacityMatrix()

  const columns = getColumns(t)

  return (
    <Wrapper data-testid={testId}>
      <TitleWrapper
        data-testid={testId ? `${testId}-title-wrapper` : undefined}
      >
        <Text as="h3" data-testid={testId ? `${testId}-title` : undefined}>
          {t('skillsAndNeeds.skillsAndNeedsCapacity')}
        </Text>
        <Popover
          placement="bottom"
          content={t('skillsAndNeeds.capacityPopover')}
          data-testid={testId ? `${testId}-help-popover` : undefined}
        >
          <div data-testid={testId ? `${testId}-help-icon` : undefined}>
            <Icon
              customIcon={IconType.Question}
              style={{ marginLeft: 5, marginBottom: 6 }}
            />
          </div>
        </Popover>
      </TitleWrapper>
      <InputSelectWrapper
        data-testid={testId ? `${testId}-filter-wrapper` : undefined}
      >
        <InputSelectStyled
          testId={testId ? `${testId}-category-filter` : 'category-filter'}
          layout="column"
          type="categories"
          placeholder={t('skillsAndNeeds.table.selectCategoriesToFilter')}
          tooltip={t('skillsAndNeeds.form.categoryTooltip')}
          onChange={onCategoryChange}
          options={categories}
          mode="multiple"
          data-testid={testId ? `${testId}-category-filter` : undefined}
        />
      </InputSelectWrapper>
      <TableStyled<CapacityTable>
        loading={false}
        pagination={false}
        columns={columns}
        dataSource={capacityMatrixRows}
        data-testid={testId ? `${testId}-table` : undefined}
      />
    </Wrapper>
  )
}

export default CapacityMatrix
